import { Action } from './action'
import { Actions } from './actions'

interface Five9InteractionModel {
    interactionId: string;
}
  
const initial: Five9InteractionModel = {
    interactionId: '',
};

export const five9Interaction = (context: any) => {
    const { log } = context;
    return (state: Five9InteractionModel = initial, action: Action<Actions>) => {
        let updated = state;
        const { type, payload } = action;
        switch (type) {
            case Actions.SET:
                updated = {
                    interactionId: payload,
                };
                break;

            case Actions.RESET:
                updated = initial;
                break;
        }
        return updated;
    }
}
